import React from 'react'
import image from '../../assets/background.jpg';
import classes from './BackgroundVideo.css'
export const BackgroundVideo = () => {
    return (
        <div className={classes.BackgroundVideo}>
            <img src={image} alt={'not loaded'}/>
        </div>
    )
}